import * as React from "react"
import { SimpleBannerStyles } from "./SimpleBannerStyles"

const SimpleBanner = ({ children, eyebrow, title }) => {
  return (
    <SimpleBannerStyles>
      {children}

      {title && (
        <div className="container">
          <div className="banner__content">
            {eyebrow && <p className="eyebrow">{eyebrow}</p>}
            <h1>
              {title}
              <span style={{ color: "var(--color-gold-500)" }}>.</span>
            </h1>
          </div>
        </div>
      )}
      <div className="gradient"></div>
    </SimpleBannerStyles>
  )
}

export default SimpleBanner
